<template>
  <div class="SJFW-container">
    <div class="BigImg">
        <p>数据服务</p>
        <a href="#bottom">咨询合作</a>

    </div>
   <ViewContentVue :list="data1" />
   <ViewContentVue :list="data2" />
  </div>
</template>

<script>
import ViewContentVue from '@/components/ViewContent.vue'
import img1 from '@/assets1/数据服务_slices/位图.png'
import img2 from "@/assets1/数据服务_slices/ai模型训练.png"
import img4 from "@/assets1/数据服务_slices/数据标注.png"
import img3 from "@/assets1/数据服务_slices/位图3.png"
export default {
components:{
  ViewContentVue
},
data(){
  return{
    data1:[{title:'数据采集',
    content:'数循提供标准或定制化的数据采集服务。采集后数据经过清洗、整理和分析后，能够为企业决策提供可靠依据，助力市场研究、用户行为分析和业务优化，提升企业竞争力和创新能力。数据采集业务是数字化转型的重要环节，帮助企业实现智能化管理和精准营销。',
    height:'442px',
    type:'right',width:'500px',
    img:'https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E6%95%B0%E6%8D%AE%E6%9C%8D%E5%8A%A1/%E4%BD%8D%E5%9B%BE.png'}],
    data2:[
      {title:'数据标注',
    content:'数据标注业务为企业提供高质量的数据标注服务，涵盖图像、文本、音频和视频等多种数据类型。通过专业团队和先进工具，对原始数据进行精准的分类、标记和注释，确保数据集的高准确性和一致性。标注后的数据广泛应用于机器学习和人工智能模型的训练，提升模型的性能和可靠性。数据标注业务帮助企业加速AI项目的开发进程，降低人力成本，助力实现智能化和自动化应用场景。',
    height:'500px',width:'500px',img:'https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E6%95%B0%E6%8D%AE%E6%9C%8D%E5%8A%A1/%E6%95%B0%E6%8D%AE%E6%A0%87%E6%B3%A8.png',
    type:'left',color:'#EEF1F8',fontColor:'#000',
    },
    {title:'数据资产代运营',
    content:'数据资产代运营业务为企业提供全面的数据管理和运营服务，涵盖数据收集、存储、处理、分析和应用等各个环节。通过专业团队和先进技术，帮助企业挖掘数据价值，提升数据质量和利用效率。代运营服务能够优化数据管理流程，降低运营成本，增强数据安全性和合规性，助力企业实现数据驱动的决策和业务创新，提升市场竞争力。',
    height:'500px',width:'500px',
    type:'right',img:'https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E6%95%B0%E6%8D%AE%E6%9C%8D%E5%8A%A1/%E4%BD%8D%E5%9B%BE3.png',fontColor:'#000',
    },
    {title:'Ai模型训练',
    content:'专注于为企业提供从数据准备到模型部署的全流程服务。包括数据清洗和标注、模型选择与设计、训练与优化、测试与评估等环节。通过利用先进的算法和高性能计算资源，快速高效地训练出满足业务需求的AI模型。此业务帮助企业提升自动化水平，优化业务流程，实现智能化应用场景，如预测分析、图像识别和自然语言处理，从而增强企业的创新能力和市场竞争力。',
    height:'500px',width:'500px',
    type:'left',img:'https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E6%95%B0%E6%8D%AE%E6%9C%8D%E5%8A%A1/ai%E6%A8%A1%E5%9E%8B%E8%AE%AD%E7%BB%83.png',fontColor:'#000',
    }
    ]
  }
},created(){
  console.log(img3);
  
}

}
</script>

<style scoped>
.BigImg{
  min-width: 1920px;
  height: 485px;
  background-image: url('https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E6%95%B0%E6%8D%AE%E6%9C%8D%E5%8A%A1/%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%ACbanner.png');
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.BigImg p{
  font-family: Heavy;
font-weight: 800;
font-size: 40px;
color: #222222;
}
.BigImg a{
  width: 200px;
height: 56px;
background-color: #0D53FF ;
line-height: 56px;
border-radius: 12px;
text-align: center;
font-family: Light;
font-weight: 400;
font-size: 20px;
color: #FFFFFF;
margin-top: 40px;
}

</style>